/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import {
  ChannelPreviewUIComponentProps,
  DefaultStreamChatGenerics,
} from "stream-chat-react";
import { Channel } from "stream-chat/dist/types/channel";
import { DefaultGenerics } from "stream-chat/dist/types/types";
import "./CustomChannelPreview.css";
import ChatListLogo from "../../../assets/chat-list-logo.png";
import CheckBox from "../../checkbox/CheckBox";

type props = {
  data: ChannelPreviewUIComponentProps<DefaultStreamChatGenerics>;
  handleChannelClick: (newChannel: Channel<DefaultGenerics>) => void;
  handleLongPress?: (channel: Channel<DefaultGenerics>) => void; // New prop for long press
  isShowCheckBox?: boolean;
  isSelected?: boolean; // New prop for selected status
};

export const CustomChannelPreview: React.FC<props> = ({
  data,
  handleChannelClick,
  handleLongPress,
  isShowCheckBox,
  isSelected,
}) => {
  const {
    channel,
    activeChannel,
    displayImage,
    displayTitle,
    lastMessage,
    setActiveChannel,
  } = data;
  const latestMessageAt = channel.state.last_message_at;
  const [pressTimeout, setPressTimeout] = useState<NodeJS.Timeout | null>(null);

  const handleMouseDown = () => {
    setPressTimeout(
      setTimeout(() => {
        handleLongPress?.(channel);
      }, 500)
    ); // 500ms for long press
  };

  const handleMouseUp = () => {
    if (pressTimeout) {
      clearTimeout(pressTimeout);
      setPressTimeout(null);
    }
  };

  const handleTouchStart = () => {
    handleMouseDown();
  };

  const handleTouchEnd = () => {
    handleMouseUp();
  };

  return (
    <div className="channel-preview-container">
      {isShowCheckBox && (
        <CheckBox
          isSelected={isSelected}
          onCheckBoxClicked={(isChecked) => {
            handleLongPress?.(channel);
          }}
          isHideText
        />
      )}
      <div
        className="channel-preview"
        onClick={() => handleChannelClick(channel)}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}>
        <img className="channel-preview__avatar" src={ChatListLogo} alt="" />
        <div className="channel-preview__main">
          <div className="channel-preview__header">{displayTitle}</div>
          <div className="channel-preview__message">
            {lastMessage ? lastMessage.text : ""}
          </div>
        </div>
      </div>
    </div>
  );
};
